import { relations } from "drizzle-orm";
import { index, pgTable, text, timestamp } from "drizzle-orm/pg-core";

import { organization } from "./auth";
import { survey, surveyArea, surveyItem } from "./surveys";
import { structureArea, structureItem } from "./structure-library";

export const recommendationTemplate = pgTable(
  "recommendation_template",
  {
    id: text("id").primaryKey(),
    organizationId: text("organization_id")
      .notNull()
      .references(() => organization.id, { onDelete: "cascade" }),
    title: text("title").notNull(),
    textTemplate: text("text_template").notNull(),
    urgency: text("urgency").notNull().default("maint"),
    defaultAreaId: text("default_area_id"),
    defaultItemId: text("default_item_id"),
    createdAt: timestamp("created_at").defaultNow().notNull(),
  },
  (table) => [
    index("recommendation_template_organization_id_idx").on(
      table.organizationId,
    ),
    index("recommendation_template_default_area_id_idx").on(
      table.defaultAreaId,
    ),
    index("recommendation_template_default_item_id_idx").on(
      table.defaultItemId,
    ),
  ],
);

export const surveyRecommendation = pgTable(
  "survey_recommendation",
  {
    id: text("id").primaryKey(),
    surveyId: text("survey_id")
      .notNull()
      .references(() => survey.id, { onDelete: "cascade" }),
    areaId: text("area_id").references(() => structureArea.id, {
      onDelete: "restrict",
    }),
    itemId: text("item_id").references(() => structureItem.id, {
      onDelete: "restrict",
    }),
    surveyAreaId: text("survey_area_id").references(() => surveyArea.id, {
      onDelete: "cascade",
    }),
    surveyItemId: text("survey_item_id").references(() => surveyItem.id, {
      onDelete: "cascade",
    }),
    recommendationText: text("recommendation_text").notNull(),
    sourceTemplateId: text("source_template_id").references(
      () => recommendationTemplate.id,
      { onDelete: "set null" },
    ),
    createdAt: timestamp("created_at").defaultNow().notNull(),
  },
  (table) => [
    index("survey_recommendation_survey_id_idx").on(table.surveyId),
    index("survey_recommendation_area_item_idx").on(table.areaId, table.itemId),
    index("survey_recommendation_survey_area_item_idx").on(
      table.surveyAreaId,
      table.surveyItemId,
    ),
    index("survey_recommendation_source_template_id_idx").on(
      table.sourceTemplateId,
    ),
  ],
);

export const recommendationTemplateRelations = relations(
  recommendationTemplate,
  ({ one, many }) => ({
    organization: one(organization, {
      fields: [recommendationTemplate.organizationId],
      references: [organization.id],
    }),
    surveyRecommendations: many(surveyRecommendation),
  }),
);

export const surveyRecommendationRelations = relations(
  surveyRecommendation,
  ({ one }) => ({
    survey: one(survey, {
      fields: [surveyRecommendation.surveyId],
      references: [survey.id],
    }),
    area: one(structureArea, {
      fields: [surveyRecommendation.areaId],
      references: [structureArea.id],
    }),
    item: one(structureItem, {
      fields: [surveyRecommendation.itemId],
      references: [structureItem.id],
    }),
    surveyArea: one(surveyArea, {
      fields: [surveyRecommendation.surveyAreaId],
      references: [surveyArea.id],
    }),
    surveyItem: one(surveyItem, {
      fields: [surveyRecommendation.surveyItemId],
      references: [surveyItem.id],
    }),
    sourceTemplate: one(recommendationTemplate, {
      fields: [surveyRecommendation.sourceTemplateId],
      references: [recommendationTemplate.id],
    }),
  }),
);
